<template>
  <div>
    <div class="wrapper my-8 mx-8">
      <p>
        <span style="color:rgb(0,170,221)">Dashboard / Patients /</span>
        {{patient.userProfile.firstName}} {{patient.userProfile.lastName}}
      </p>
      <div class="cell mt-10" style="position:relative;">
        <v-row no-gutters>
          <v-col sm="4" md="3">
            <div class="" style="margin-top:100px; display:flex; flex-direction:column; align-items:center">
              <img :src="patient.userProfile.profilePic" style="border-radius:50%; height:100px; width:100px;" alt="img" />
              <h3 class="mt-8">{{patient.userProfile.firstName}} {{patient.userProfile.lastName}}</h3>
              <p>{{patient.userProfile.username}}</p>
              <!-- <p :class="patient.status" class="px-2 text-uppercase white--text">{{patient.status}}</p> -->

              <p class="white--text px-4 pt-1 mt-2" :class="patient.userProfile.isBlocked ? 'blocked' : 'green'">{{patient.userProfile.isBlocked ? 'BLOCKED' : 'ACTIVE'}}</p>
              <div class="mt-10" style="width:40%; background-color:rgb(218,224,231); height:1px;"></div>
              <p class="mt-2 text-center">
                Registration Date:
                <span class="black--text">{{convertDate(patient.createdAt)}}</span>
              </p>

              <div class="mt-12 mb-2" v-if="!patient.userProfile.isBlocked">
                <v-btn
                  class="text-capitalize"
                  color="rgb(222,36,65)"
                  text
                  @click="blockDialog=true"
                >
                  <img src="/img/ban.svg" class="mr-2" style="height:20px; width:auto;" alt="">
                  Block Patient
                </v-btn>
              </div>

              <div v-else class="mt-12 mb-2">
                <v-btn
                  class="text-capitalize"
                  color="rgb(141,141,141)"
                  text
                  @click="unblockDialog=true"
                >
                <img src="/img/approve.svg" class="mr-2" style="height:20px; width:auto;" alt="">
                Unblock Patient</v-btn>
              </div>
            </div>
          </v-col>
          <hr class="mr-1 my-10 " style="align-self:strech; border-color:rgb(242,242,242);" />
          <v-col class="right-col" sm="7" md="8">
            <div class="ml-12">
              <v-tabs color="rgb(0,169,221)">
                <v-tab>General Info</v-tab>
                <v-tab>Activity</v-tab>
                <v-tab>History</v-tab>

                <v-tab-item>
                  <div style="display:flex;flex-direction:column;">
                    <h4 class="mt-10">Personal Info</h4>
                    <v-row no-gutters>
                      <v-col sm="12" md="10">

                        <v-row no-gutters>
                          <v-col md="4" sm="6">
                            <p>First Name:</p>
                          </v-col>
                          <v-col md="4" sm="6">
                            <p class="black--text">{{patient.userProfile.firstName}}</p>
                          </v-col>
                        </v-row>

                        <v-row no-gutters>
                          <v-col md="4" sm="6">
                            <p>Last Name:</p>
                          </v-col>
                          <v-col md="4" sm="6">
                            <p class="black--text">{{patient.userProfile.lastName}}</p>
                          </v-col>
                        </v-row>

                        <v-row no-gutters>
                          <v-col md="4" sm="6">
                            <p>Username:</p>
                          </v-col>
                          <v-col md="4" sm="6">
                            <p class="black--text">{{patient.userProfile.username}}</p>
                          </v-col>
                        </v-row>

                        <v-row no-gutters>
                          <v-col md="4" sm="6">
                            <p>Country:</p>
                          </v-col>
                          <v-col md="4" sm="6">
                            <p class="black--text">{{patient.userProfile.homeCountryName}}</p>
                          </v-col>
                        </v-row>

                        <v-row no-gutters>
                          <v-col md="4" sm="6">
                            <p>Mobile:</p>
                          </v-col>
                          <v-col md="4" sm="6">
                            <p class="black--text">{{patient.userProfile.mobile}}</p>
                          </v-col>
                        </v-row>

                        <!-- <v-row no-gutters>
                          <v-col md="4" sm="6">
                            <p>City:</p>
                          </v-col>
                          <v-col md="4" sm="6">
                            <p class="black--text">{{patient.userProfile.city}}</p>
                          </v-col>
                        </v-row> -->

                        <v-row no-gutters>
                          <v-col md="4" sm="6">
                            <p>Date of Birth:</p>
                          </v-col>
                          <v-col md="4" sm="6">
                            <p class="black--text">{{patient.userProfile.birthDate ? convertDate(patient.userProfile.birthDate) : '-'}}</p>
                          </v-col>
                        </v-row>

                        <v-row no-gutters>
                          <v-col md="4" sm="6">
                            <p>Gender:</p>
                          </v-col>
                          <v-col md="4" sm="6">
                            <p class="black--text">{{patient.userProfile.gender == 'm' ? 'Male': patient.userProfile.gender == 'f' ? 'female' : ''}}</p>
                          </v-col>
                        </v-row>

                        <v-row no-gutters>
                          <v-col md="4" sm="6">
                            <p>Registration Email:</p>
                          </v-col>
                          <v-col md="4" sm="6">
                            <p class="black--text">{{patient.userProfile.email}}</p>
                          </v-col>
                        </v-row>

                        <v-row no-gutters>
                          <v-col md="4" sm="6">
                            <p>Registration Date:</p>
                          </v-col>
                          <v-col md="4" sm="6">
                            <p class="black--text">{{convertDate(patient.createdAt)}}</p>
                          </v-col>
                        </v-row>

                        <v-row no-gutters>
                          <v-col md="4" sm="6">
                            <p>Language(s):</p>
                          </v-col>
                          <v-col md="4" sm="6">
                            <div class="d-flex" v-for="(language, index) in patient.spokenLanguages" :key="index">
                              <p class="black--text">{{language.languageName}}<span v-if="index < patient.spokenLanguages.length - 1">,</span> </p>
                            </div>
                            
                          </v-col>
                        </v-row>

                      </v-col>
                    </v-row>

                    <h4 class="mt-5">Travel Insurance</h4>
                    <v-row>
                     <v-col sm="12" md="10">

                        <v-row no-gutters>
                          <v-col md="4" sm="6">
                            <p>Insured:</p>
                          </v-col>
                          <v-col md="4" sm="6">
                            <p class="black--text">{{patient.isInsured ? 'Yes' : 'No'}}</p>
                          </v-col>
                        </v-row>

                        <!-- <v-row no-gutters>
                          <v-col md="4" sm="6">
                            <p>Insurance Name:</p>
                          </v-col>
                          <v-col md="4" sm="6">
                            <p class="black--text">todo</p>
                          </v-col>
                        </v-row> -->

                        <v-row no-gutters>
                          <v-col md="4" sm="6">
                            <p>Policy No:</p>
                          </v-col>
                          <v-col md="4" sm="6">
                            <p class="black--text">{{patient.insurancePolicy ? patient.insurancePolicy.insurancePolicyNum ? patient.insurancePolicy.insurancePolicyNum : '-' : '-'}}</p>
                          </v-col>
                        </v-row>

                        <v-row no-gutters>
                          <v-col md="4" sm="6">
                            <p>Assistant Ref No:</p>
                          </v-col>
                          <v-col md="4" sm="6">
                            <p class="black--text">{{patient.insurancePolicy ? patient.insurancePolicy.assistantRefNum ? patient.insurancePolicy.assistantRefNum : '-' : '-'}}</p>
                          </v-col>
                        </v-row>

                        <v-row no-gutters>
                          <v-col md="4" sm="6">
                            <p>Country of Destination:</p>
                          </v-col>
                          <v-col md="4" sm="6">
                            <p class="black--text">todo</p>
                          </v-col>
                        </v-row>

                        <v-row no-gutters>
                          <v-col md="4" sm="6">
                            <p>Travel Dates:</p>
                          </v-col>
                          <v-col md="4" sm="6">
                            <p class="black--text">{{patient.insurancePolicy ? patient.insurancePolicy.policyStartDate ? convertDate(patient.insurancePolicy.policyStartDate) : '-' : '-'}} - {{patient.insurancePolicy ? patient.insurancePolicy.policyEndDate ? convertDate(patient.insurancePolicy.policyEndDate) : '-' : '-'}}</p>
                          </v-col>
                        </v-row>

                      </v-col>
                    </v-row>
                  </div>
                </v-tab-item>
                <v-tab-item>activity</v-tab-item>
                <v-tab-item>history</v-tab-item>
              </v-tabs>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>

      <v-dialog v-model="blockDialog" width="500">
      <v-card class="pt-12">
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center">
            <h1>Block {{patient ? patient.userProfile.firstName : ''}} {{patient ? patient.userProfile.lastName : ''}}?</h1>
            <p class="text-center mt-4">
              Prevent this user from being able to request a doctor or book any appointments with doctors or healthcare facilities).
              However they are still allowed to login to make changes to their profile and access their history or other personal info.
            </p>
          </div>
          <div class="d-flex justify-center mt-4">
            <v-btn
              class="text-capitalize mr-2"
              outlined
              color="rgb(164,164,164)"
              rounded
              @click="blockDialog=false"
            >cancel</v-btn>
            <v-btn
              class="text-capitalize white--text"
              rounded
              color="rgb(255,0,0)"
              @click="block(patient)"
            >Block</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="unblockDialog" width="500">
      <v-card class="pt-12">
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center">
            <h1>Unblock {{patient ? patient.userProfile.firstName : ''}} {{patient ? patient.userProfile.lastName : ''}}?</h1>
            <p class="text-center mt-4">
              This user will be re-activated and able to use your services again (request for a doctor in case of an emergency, book appointments etc).
            </p>
          </div>
          <div class="d-flex justify-center mt-4">
            <v-btn
              class="text-capitalize mr-2"
              outlined
              color="rgb(164,164,164)"
              rounded
              @click="unblockDialog=false"
            >cancel</v-btn>
            <v-btn
              class="text-capitalize white--text"
              rounded
              color="rgb(113,210,48)"
              @click="unblock(patient)"
            >Unblock</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      blockDialog:false,
      unblockDialog:false,
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ]
    }
  },
  methods:{
    convertDate(date2) {
      const date = new Date(date2);
      const day = date.getDate();
      const month = date.getMonth();
      const year = date.getFullYear();
      return day + " " + this.months[month].substr(0, 3) + " " + year;
    },
    block(patient) {
      const credentials = {
        userId: patient.userProfile.userId,
        isBlocked: true
      };
      this.$store.dispatch("blockPatient", credentials).then(() => {
        this.blockDialog = false;
      });
    },
    unblock(patient) {
      const credentials = {
        userId: patient.userProfile.userId,
        isBlocked: false
      };
      this.$store.dispatch("unblockPatient", credentials).then(() => {
        this.unblockDialog = false;
      });
    }
  },
  computed: {
    patient() {
      return this.$store.state.patients.patients.find(
        patient => patient.userProfile.userId === this.$route.params.id
      );
    }
  }
};
</script>

<style scoped>
p {
  margin: 0;
  color: rgb(107, 107, 107);
}

</style>